const routes = [
  {
    path: '',
    component: () => import('@/views/eden/personnel/Wrapper.vue'),
    children: [
      {
        path: '/eden/personnel',
        name: 'edenPersonnel',
        component: () => import('@/views/eden/personnel/Main.vue'),
      },
      {
        path: '/eden/personnel/:id',
        name: 'edenPersonnelDetails',
        component: () => import('@/views/eden/personnel/Details.vue'),
      },
    ],
  },
]

export default routes
